import React, { useState } from 'react';
import { HelpCircleIcon, ChevronDownIcon } from 'lucide-react';
import { useTranslation } from '../../lib/i18n';
import { getFaqs } from '../../data/faqs';
import { motion, AnimatePresence } from 'framer-motion';
export function FAQ() {
  const {
    lang
  } = useTranslation();
  const en = lang === 'en';
  const ru = lang === 'ru';
  const faqs = getFaqs(lang);
  return <section className="py-16 md:py-20 bg-dark-bg border-b-2 border-dark-border" data-id="element-222" data-mp="2bmo48mmep27o">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-223" data-mp="2bkbcjhqujdhf">
        <div className="text-center mb-10 md:mb-12" data-id="element-224" data-mp="27k9nc82ascj1">
          <div className="w-14 h-14 bg-brand-yellow/10 rounded-full flex items-center justify-center mx-auto mb-4" data-id="element-225" data-mp="22lpxvxohwilx">
            <HelpCircleIcon className="w-7 h-7 text-brand-yellow" data-id="element-226" data-mp="1xner5vthyo7x" />
          </div>
          <h2 className="text-3xl md:text-4xl font-black text-white mb-2" data-id="element-227" data-mp="ucvbfa02mt1">
            {en ? 'Frequently Asked Questions' : ru ? 'Часто задаваемые вопросы' : 'Često postavljana pitanja'}
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-3 md:gap-4" data-id="element-228" data-mp="zjtz325zmtt3">
          {faqs.map((faq, i) => <FAQItem key={i} question={faq.q} answer={faq.a} data-id="element-229" data-mp="pj9t5m7ix14j" data-mpi={i} />)}
        </div>
      </div>
    </section>;
}
function FAQItem({
  question,
  answer
}: {
  question: string;
  answer: string;
}) {
  const [isOpen, setIsOpen] = useState(false);
  return <div className={`bg-dark-surface border rounded-industrial overflow-hidden transition-colors duration-200 ${isOpen ? 'border-brand-yellow/60' : 'border-dark-border hover:border-brand-yellow/40'}`} data-id="element-230" data-mp="1i99zzqll4oa1">
      <button onClick={() => setIsOpen(!isOpen)} className="w-full px-5 py-3.5 flex items-center justify-between text-left focus:outline-none focus:ring-2 focus:ring-brand-yellow gap-3" data-id="element-231" data-mp="18hvu9131is8g">
        <span className="text-base font-bold text-white" data-id="element-232" data-mp="214qcdrcdxfir">{question}</span>
        <ChevronDownIcon className={`w-5 h-5 text-brand-yellow flex-shrink-0 transition-transform duration-300 ${isOpen ? 'rotate-180' : ''}`} data-id="element-233" data-mp="25ybb5llsydj0" />
      </button>
      <AnimatePresence data-id="element-234" data-mp="2au5pkmejnx5j">
        {isOpen && <motion.div initial={{
        height: 0,
        opacity: 0
      }} animate={{
        height: 'auto',
        opacity: 1
      }} exit={{
        height: 0,
        opacity: 0
      }} transition={{
        duration: 0.3
      }} data-id="element-235" data-mp="2ascf0w0t8ss9">
            <div className="px-7 pt-5 pb-7 text-sm md:text-base text-gray-400 leading-relaxed" data-id="element-236" data-mp="1s2cveonqo5w8">
              {answer}
            </div>
          </motion.div>}
      </AnimatePresence>
    </div>;
}